import { createApp } from 'vue';
import PropertiesGallery from '../components/PropertiesGallery.vue';

const app = createApp(PropertiesGallery);
app.mount('#propPageGallery');
